<ng-content></ng-content>
<span class="sort-icon">
  <app-shared-material-icon icon="switch_left"></app-shared-material-icon>
</span>
